import { RecentlyViewedProductV3 } from '@/common/utils/recentlyViewed/recentlyViewed';
import { GalleryItemV2 } from 'generatedBfw/static';

export const convertRecentlyViewedForGalleryItem = (
  recentlyViewed: RecentlyViewedProductV3,
): GalleryItemV2 => {
  return {
    internalId: recentlyViewed.inId,
    externalId: recentlyViewed.id,
    imageCoreUrl: recentlyViewed.imgCore,
    orientation: recentlyViewed.orient,
    title: recentlyViewed.alt,
  };
};
